import get from 'lodash/get';
import { ContextRoutesMap } from '@Services/Catalyst/CatalystConstants';
import { NODE_ENV } from '@Constants/BuildInfo';
import CatalystConfig from '@Services/Catalyst/CatalystConfig';
import StateTimeTracker from '@Services/StateTimeTracker';

export class PageDataService {
  pageData = CatalystConfig.getDefaultPageData();

  pageNames = CatalystConfig.getPageNames();

  _setPageProperty(key, value) {
    this.pageData[key] = value;
  }

  _getPageProperty(key) {
    return this.pageData[key];
  }

  _deletePageProperty(key) {
    delete this.pageData[key];
  }

  _definePageName(route, params) {
    let context;
    if (route !== 'main.search.quick.results') {
      context = get(params, 'context', null) || get(params, 'resultsByType.0.name', null);
    }
    const currentRoute = ContextRoutesMap[context] || route;
    this._setPageProperty('name', this.pageNames[currentRoute]);
  }

  _definePageEnv() {
    this._setPageProperty('environment', NODE_ENV);
  }

  /**
   * @ngdoc method
   * @name getPageData
   * @methodOf  Catalyst.PageData
   * @param {String} route
   * @param {Object} params
   */
  getPageData = (route, params) => {
    if (route) {
      this._definePageName(route, params);
    }
    this._definePageEnv();
    return this.pageData;
  };

  /**
   * @ngdoc method
   * @name setResultsTime
   * @methodOf  Catalyst.PageData
   */
  setResultsTime = () => {
    // tracking the time between the last event (router nav) and getting the data from server (results preview)
    this._setPageProperty('loadTime', new Date().getTime() - this.pageData.loadTimestamp || 0);
  };

  /**
   * @ngdoc method
   * @name setPageTimestamp
   * @methodOf  Catalyst.PageData
   */

  setPageTimestamp() {
    // this is needed only when the data is being loaded, angular router is fast, no need to track
    // eslint-disable-next-line prefer-rest-params
    this._setPageProperty('loadTime', StateTimeTracker.end(...arguments));
    this._setPageProperty('loadTimestamp', new Date().getTime());
  }

  /**
   * @ngdoc method
   * @name getPageName
   * @methodOf  Catalyst.PageData
   * @returns {String}
   */
  getCurrentPageName = () => {
    return get(this.pageData, 'name', '');
  };

  /* Initial page load functionality */
  setInitialPageLoad(loadTime) {
    this._setPageProperty('extendedName', 'initial');
    this._setPageProperty('loadTime', loadTime);
    this._setPageProperty('loadTimestamp', Date.now());
  }

  unsetInitialPageLoad() {
    this._deletePageProperty('extendedName');
  }

  shouldTrackPageLoad = () => {
    return this._getPageProperty('extendedName') === 'initial';
  };
}

const PageData = new PageDataService();
export default PageData;
